var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDevices = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 19v-3.96 3.15"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 19h5"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 10,
  x: 16,
  y: 12,
  rx: 2
})));
export default SvgDevices;